import { formatDistanceToNow } from "date-fns";

export const formatRelativeDate = (createdAt) => {
    let date;

    // If Firestore Timestamp with toDate method
    if (typeof createdAt?.toDate === 'function') {
        date = createdAt.toDate();
    }
    // If string like "30 May 2025 at 16:00:34 UTC+5:30"
    else if (typeof createdAt === 'string') {
        // Replace 'at' with empty string to make it parseable
        const cleaned = createdAt.replace(' at ', ' ');
        date = new Date(cleaned);
    }
    // If normal JS date string or timestamp
    else {
        date = new Date(createdAt);
    }

    // Fallback in case of invalid date
    if (isNaN(date.getTime())) return '';

    return formatDistanceToNow(date, { addSuffix: true }); // e.g., "3 minutes ago"
};

export const formatDate = (createdAt) => {
    const date =
        typeof createdAt.toDate === "function" ? createdAt.toDate() : new Date(createdAt);
    return date.toLocaleString("en-US", {
        dateStyle: "medium",
        timeStyle: "short",
    });
};

export const formatDuration = (duration) => {
  const totalSeconds = Math.floor(Number(duration));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  // Show hours only if > 0
  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds
      .toString()
      .padStart(2, '0')}`;
  }

  // Else show MM:SS
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};